import { Shield, Thermometer, Wrench } from "lucide-react";
import { Card } from "./ui/card";
import { Link } from "react-router-dom";

const services = [
  {
    title: "Noise Reduction",
    description: "Significantly reduce external noise for a quieter, more peaceful living environment.",
    icon: Shield,
    image: "/lovable-uploads/6bbd10ac-cd7f-4d4f-a93a-e6bad519e5a5.png",
    link: "/noise-reduction-secondary-glazing"
  },
  {
    title: "Thermal Insulation",
    description: "Improve energy efficiency and reduce heating costs with superior insulation.",
    icon: Thermometer,
    image: "/lovable-uploads/adf9c9e5-3422-4a0b-9a4c-2e8d52dffeae.png",
    link: "/thermal-insulation-secondary-glazing"
  },
  {
    title: "Custom Solutions",
    description: "Tailored secondary glazing solutions to match your property's unique requirements.",
    icon: Wrench,
    image: "/lovable-uploads/eb808621-776c-455b-b0e2-bf10f9627fdf.png",
  },
];

export const Services = () => {
  return (
    <section id="services" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-primary font-montserrat sm:text-4xl">Our Services</h2>
          <p className="mt-4 text-xl text-secondary font-inter">
            Professional secondary glazing solutions for every need
          </p>
        </div>

        <div className="mt-20 grid grid-cols-1 gap-12 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((service) => {
            const imageEl = (
              <div className="relative h-48 overflow-hidden">
                <img
                  src={service.image}
                  alt={`${service.title} - Professional secondary glazing service in London`}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                  width={400}
                  height={192}
                  loading="lazy"
                  decoding="async"
                  sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors duration-300" />
                <div className="absolute top-4 left-1/2 -translate-x-1/2 bg-primary rounded-full p-4 group-hover:bg-accent transition-colors duration-300">
                  <service.icon className="w-8 h-8 text-white" />
                </div>
              </div>
            );

            const textEl = (
              <div className="p-6">
                <h3 className="text-xl font-semibold text-primary font-montserrat">{service.title}</h3>
                <p className="mt-4 text-secondary font-inter">{service.description}</p>
              </div>
            );

            return (
              <Card
                key={service.title}
                className="relative group overflow-hidden hover:shadow-xl transition-all duration-300"
              >
                {service.link ? (
                  <Link to={service.link}>
                    {imageEl}
                    {textEl}
                  </Link>
                ) : (
                  <>
                    {imageEl}
                    {textEl}
                  </>
                )}
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
